import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { firstListItem } from '@/constants/defaultValues';
import { getLabel } from '@/helpers/Utils';

export const fetchEmployeeGroup = createAsyncThunk(
  'employeeGroup/fetchEmployeeGroup',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetEmployeeGroup();
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          label: item.name,
          type: item.type,
          parent: item.parent,
          value: item.id,
        })) ?? [];
      return [firstListItem, ...mappedData];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  employeeGroupList: [],
  loading: false,
  error: '',
};

const employeeGroupSlice = createSlice({
  name: 'employeeGroup',
  initialState,
  reducers: {
    addNewEmployeeGroup: (state, action) => {
      state.employeeGroupList = [
        {
          id: action.payload.id,
          value: action.payload.id,
          nameEn: action.payload.nameEn,
          nameAr: action.payload.nameAr,
          label: getLabel(action.payload.nameAr, action.payload.nameEn),
          parentID: action.payload?.parentID,
          parent: action.payload?.parent,
          type: action.payload.type,
        },
        ...state.employeeGroupList,
      ];
      state.loading = false;
      state.error = '';
    },
    updateEmployeeGroup: (state, action) => {
      const updatedItem = {
        id: action.payload.id,
        value: action.payload.id,
        nameEn: action.payload.nameEn,
        nameAr: action.payload.nameAr,
        label: getLabel(action.payload.nameAr, action.payload.nameEn),
        parentID: action.payload?.parentID,
        parent: action.payload?.parent,
        type: action.payload.type,
      };
      const updatedList = state.employeeGroupList
        .filter((x) => x.id != '')
        .map((item) =>
          item.id === updatedItem.id ? { ...item, ...updatedItem } : item
        );
      state.employeeGroupList = [...updatedList, firstListItem];
      state.loading = false;
      state.error = '';
    },
    deleteEmployeeGroup: (state, action) => {
      const filteredList = state.employeeGroupList.filter(
        (item) => item.id !== action.payload
      );
      state.employeeGroupList = filteredList;
      state.loading = false;
      state.error = '';
      console.log(state.employeeGroupList);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployeeGroup.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmployeeGroup.fulfilled, (state, action) => {
        state.loading = false;
        state.employeeGroupList = action.payload;
        state.error = '';
      })
      .addCase(fetchEmployeeGroup.rejected, (state, action) => {
        state.loading = false;
        state.employeeGroupList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default employeeGroupSlice.reducer;
